import { vatDescription } from '../helpers/vatDescription';

export const registrationPersonalDataFields = [
  // {
  //   fieldName: 'Country',
  //   isRequired: true,
  //   label: 'Country',
  //   type: 'select',
  //   placeholder: 'Choose a country',
  //   options: country ? [
  //     {
  //       label: country.name,
  //       value: country.code
  //     }
  //   ] : [],
  // },
  {
    fieldName: 'Email',
    isRequired: true,
    label: 'E-mail',
    type: 'email'
  },
  {
    fieldName: 'Phone',
    isRequired: true,
    label: 'Phone',
    type: 'text'
  },
  {
    fieldName: 'Password',
    isRequired: true,
    label: 'Password',
    type: 'password'
  },
  {
    fieldName: 'Firstname',
    isRequired: true,
    label: 'First name',
    type: 'text',
  },
  {
    fieldName: 'Lastname',
    isRequired: true,
    label: 'Last name',
    type: 'text'
  },
];

export const registrationBillingFields = [
  {
    fieldName: 'Address',
    type: 'address',
    isRequired: true,
  },
  {
    fieldName: 'AnotherDeliveryAddress',
    label: 'Different delivery address',
    type: 'bool',
  },
  {
    fieldName: 'DeliveryAddress',
    type: 'address',
    isRequired: true
  },
  {
    fieldName: 'CompanyInformation',
    label: 'Company information',
    type: 'bool',
  },
  {
    fieldName: 'CompanyName',
    label: 'Company name',
    type: 'text',
  },
  {
    fieldName: 'CompanyVatNumber',
    label: `Company ${vatDescription()} number`,
    type: 'text'
  },
  {
    fieldName: 'CompanyRegistrationNumber',
    label: 'Company reg. number',
    type: 'text'
  },
  // {
  //   fieldName: 'Conditions',
  //   type: 'bool',
  //   isRequired: true,
  //   label:
  //     'Souhlasím s <b>obchodními podmínkami</b> a se zpracováním osobních údajů.',
  //   validationMessage: 'Musíte souhlasit s obchodními podmínkami.'
  // }
];


// WEBPACK FOOTER //
// ./src/formFields/registration.tsx